import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LocationInfoContainer } from '../containers/LocationInfoContainer.js';

const LocationInfo = (props)=>/*#__PURE__*/ React.createElement(LocationInfoContainer, swcHelpers.extends({}, props))
;

export { LocationInfo };
//# sourceMappingURL=LocationInfo.js.map
